var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-bar-preview",style:({
        marginLeft: (_vm.$$FormData.page_edge ) * 0.5 + 'px',
        marginRight: (_vm.$$FormData.page_edge ) * 0.5 + 'px',
        marginTop: (_vm.$$FormData.page_top_edge ) * 0.5 + 'px',
        padding: (_vm.$$FormData.page_edge ) * 0.5 + 'px',
        borderRadius: (_vm.$$FormData.page_radius ) * 0.5 + 'px',
        backgroundColor: `${_vm.$$FormData.background_color}`
      })},[_c('div',{staticClass:"left-content"},[(_vm.$$FormData.show_left_icon)?_c('div',{staticClass:"left-icon"},[_c('img',{attrs:{"src":`${_vm.$$FormData.left_icon_bg_style}`,"alt":""}})]):_vm._e(),_c('div',{staticClass:"news-content",style:({
        fontSize: (_vm.$$FormData.content_font_size ) * 0.5 + 'px',
        color: _vm.$$FormData.content_color
      })},[_vm._v(_vm._s(_vm.$$FormData.content || _vm.default_news))])]),(_vm.$$FormData.show_right_icon)?_c('div',{staticClass:"right-icon"},[_c('img',{attrs:{"src":`${_vm.$$FormData.right_icon_bg_style}`,"alt":""}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }